module.exports = __webpack_public_path__ + "static/kran02_512-bc05330f537c5e09cfc32121d75df906.jpg";